<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="MeterConsumptionBrowser"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <VueSlickgrid
    :name="gridName"
    :headerTitle="'Meter Consumptions'|pgettext('MeterConsumptionBrowser')"
    :items="ds"
    checkbox-row-selection
    export-to-csv
    :exportToCsvFilename="'meter-consumptions'|pgettext('MeterConsumptionBrowser|ExportFilename')"
    footer-totals
    :columnDefaults="b_2248226175642056_columnDefaults"
    :columns="b_2248226175642056_columns"
    class="page--grid"
    ref="grid"
    @selectedRowsChanged="evh_2248226175642056_selectedRowsChanged($event, {})"
    @command="evh_2248226175642056_command($event, {})"
  >
    <DIV
      class="flex-grow-1 d-flex"
      slot="toolbar"
    >
      <DIV
        class="ml-3"
      >
        <ItpFormCheckbox
          name="unbilled_only"
          :label="'Unbilled only'|pgettext('MeterConsumptionBrowser')"
          inline
          v-model="dsParams.unbilled_only"
          @input="evh_4615685607825208_input($event, {})"
        >
        </ItpFormCheckbox>
      </DIV>
      <ItpButton
        :icon="$config.uploadIcon"
        :text="'Upload readings...'|pgettext('MeterConsumptionBrowser')"
        size="sm"
        variant="light"
        class="ml-3"
        @click="evh_8320016629450276_click($event, {})"
      >
      </ItpButton>
      <JobHandlerControl
        jobType="generate_meter_consumptions"
        load-current
        :payload="onGenerateMeterConsumptions"
        icon="material-symbols:cloud-sync-outline-rounded"
        :text="'Generate Consumptions'|pgettext('GenerateMeterConsumptions|Submit')"
        size="sm"
        class="ml-3"
      >
      </JobHandlerControl>
      <ItpButton
        :icon="$config.meterConsumption.createMeterConsumptionIcon"
        :text="'Add consumption...'|pgettext('MeterConsumptionBrowser')"
        size="sm"
        variant="light"
        class="ml-3"
        @click="evh_6806515264385235_click($event, {})"
      >
      </ItpButton>
      <ItpButton
        icon="fa-trash"
        :title="'Delete consumption'|pgettext('MeterConsumptionBrowser')"
        :text="'Delete'|gettext"
        size="sm"
        variant="light"
        :disabled="!selectedItems || !selectedItems.length"
        :spinning="actions.deleteItems.isRunning"
        class="ml-3"
        @click="evh_8116269939469002_click($event, {})"
      >
      </ItpButton>
      <JobHandlerControl
        jobType="create_invoices_from_consumptions"
        load-current
        :payload="onCreateInvoicesPayload"
        icon="mdi:cog"
        :text="'Generate Invoices'|pgettext('MeterConsumptions|Submit')"
        :disabled="!selectedItems || !selectedItems.length"
        size="sm"
        class="ml-3 pl-3 border-left"
      >
      </JobHandlerControl>
    </DIV>
  </VueSlickgrid>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "meterConsumptions",
    path: "/meter-consumptions",
    component: "MeterConsumptionBrowser"
  }
)

@Component()
export default class MeterConsumptionBrowser extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_dsParams = new ComponentValueCache(this, "dsParams", "MeterConsumptionBrowser.dsParams");
  }

  onCreateInvoicesPayload(...args: any[]) {
    return { consumptions: _.map(this.selectedItems, 'id') }
  }

  onGenerateMeterConsumptions(...args: any[]) {
    return this.$imodal
      .show({ name: 'GenerateMeterConsumptions' })
      .then(result => {
        console.log(result)
        if (!result || result.cancel || !result.value) {
          return;
        }
        this.$emit('slickgrid:reload', { grid: this.gridName });
        return result.value;
      })
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  gridName!: any;
  selectedItems!: any;
  dsParams!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('integro_api/browse_meter_consumption', {
      parameters: () => ({
        ...this.dsParams,
        unbilled_only: this.dsParams.unbilled_only ? 1 : null

      })
    })
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2248226175642056_columnDefaults!: any;
  b_2248226175642056_columns!: any;
  dataMembers = ['gridName', 'selectedItems', 'dsParams', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        gridName: "meterConsumptions",
        selectedItems: [
        ]
        ,
        dsParams: {
          unbilled_only: true,
        }
        ,
        ds: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2248226175642056_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
          selectable: true,
        }
        ,
        b_2248226175642056_columns: [{
          field: "invoice",
          name: this.$fn.pgettext("MeterConsumptionBrowser", "Invoice"),
          params: {
            sortPath: "invoice.invoice_number",
          }
          ,
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <a href=\"#\" onclick=\"return false;\">\n\
      <strong title=\"{{ $value.invoice_number }}\">{{ $value.invoice_number }}</strong>\n\
    </a>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "meter",
          name: this.$fn.pgettext("MeterConsumptionBrowser", "Meter"),
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong>{{ $value.serial_number }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "meter",
              navigateOnIconClick: true,
              params: {
                id: "meter.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "meter_type",
          name: this.$fn.pgettext("MeterBrowser", "Meter type"),
          params: {
            sortPath: "meter.meter_type",
          }
          ,
          formatter: [{
            name: "getvalue",
            opts: {
              field: "meter.meter_type",
            }
            ,
          }
            ,
          {
            name: "gettext",
            context: "MeterTypes",
            conversion: "Sentence",
            filterInput: true,
          }
            ,
          ]
          ,
        }
          ,
        {
          field: "meter_description",
          name: this.$fn.pgettext("MeterBrowser", "Description"),
          params: {
            sortPath: "meter.description",
          }
          ,
          formatter: [{
            name: "getvalue",
            opts: {
              field: "meter.description",
            }
            ,
          }
            ,
          ]
          ,
        }
          ,
        {
          field: "meter_tag_id",
          name: this.$fn.pgettext("MeterBrowser", "Tag ID"),
          params: {
            sortPath: "meter.tag_id",
          }
          ,
          formatter: [{
            name: "getvalue",
            opts: {
              field: "meter.tag_id",
            }
            ,
          }
            ,
          ]
          ,
        }
          ,
        {
          field: "start.date",
          type: "date",
          name: this.$fn.pgettext("MeterConsumptionBrowser", "Start date"),
          params: {
            sortPath: "start.date",
          }
          ,
          formatter: [{
            name: "getvalue",
            opts: {
              field: "start.date",
            }
            ,
          }
            ,
          ]
          ,
        }
          ,
        {
          field: "start.reading",
          type: "number",
          name: this.$fn.pgettext("MeterConsumptionBrowser", "Start reading"),
          params: {
            sortPath: "start.reading",
          }
          ,
          formatter: [{
            name: "getvalue",
            opts: {
              field: "start.reading",
            }
            ,
          }
            ,
          {
            name: "number",
          }
            ,
          ]
          ,
        }
          ,
        {
          field: "end.date",
          type: "date",
          name: this.$fn.pgettext("MeterConsumptionBrowser", "End date"),
          params: {
            sortPath: "end.date",
          }
          ,
          formatter: [{
            name: "getvalue",
            opts: {
              field: "end.date",
            }
            ,
          }
            ,
          ]
          ,
        }
          ,
        {
          field: "end.reading",
          type: "number",
          name: this.$fn.pgettext("MeterConsumptionBrowser", "End reading"),
          params: {
            sortPath: "end.reading",
          }
          ,
          formatter: [{
            name: "getvalue",
            opts: {
              field: "end.reading",
            }
            ,
          }
            ,
          {
            name: "number",
          }
            ,
          ]
          ,
        }
          ,
        {
          field: "total_consumption",
          name: this.$fn.pgettext("MeterConsumptionBrowser", "Total"),
          type: "number",
          formatter: {
            name: "chain",
            mode: "mapReduce",
          }
          ,
        }
          ,
        {
          field: "unit",
          name: this.$fn.pgettext("MeterConsumptionBrowser", "Unit"),
        }
          ,
        {
          field: "billing_factor",
          type: "number",
          name: this.$fn.pgettext("MeterConsumptionBrowser", "Billing multiplier"),
        }
          ,
        {
          field: "billing_category",
          name: this.$fn.pgettext("MeterConsumptionBrowser", "Billing category"),
        }
          ,
        {
          field: "non_billable",
          name: this.$fn.pgettext("MeterConsumptionBrowser", "Non-billable"),
          formatter: "checkbox",
        }
          ,
        {
          field: "tariff",
          name: this.$fn.pgettext("MeterConsumptionBrowser", "Tariff"),
        }
          ,
        {
          field: "rental",
          name: this.$fn.pgettext("MeterConsumptionBrowser", "Rental"),
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong>{{ $value.name }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "rental",
              navigateOnIconClick: true,
              params: {
                id: "rental.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "consumer",
          name: this.$fn.pgettext("MeterConsumptionBrowser", "Consumer"),
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong>{{ $value.code }} | {{ $value.name }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "company",
              navigateOnIconClick: true,
              params: {
                id: "consumer.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "created_at",
          name: this.$fn.pgettext("BrowserColumn", "Create time"),
          formatter: "datetime",
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.gettext("MeterConsumptionBrowser"),
        icon: this.$config.meterConsumption.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_4450_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_4450, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_setData_4452_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2248226175642056_setData_4452, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_2248226175642056_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_reloadSlickgrid_4456_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2248226175642056_reloadSlickgrid_4456, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_2248226175642056_close_4455_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_close_4455, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_2248226175642056_showModal_4454_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_4454, alias=undefined
    return {
      name: "MeterConsumption",
      props: {
        oid: $event.data.data.id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_4453_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_4453, alias=undefined
    return $event.data.column.id === 'total_consumption'
  }

  async act_2248226175642056_showModal_4458_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_4458, alias=undefined
    return {
      name: "Invoice",
      props: {
        oid: $event.data.data.invoice.id,
        modal: true,
      }
      ,
    }
  }

  async evh_2248226175642056_command_4457_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_4457, alias=undefined
    return $event.data.column.id === 'invoice'
  }

  async evh_2248226175642056_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
  }

  async act_4615685607825208_reloadSlickgrid_4460_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_4615685607825208_reloadSlickgrid_4460, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_4615685607825208_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4615685607825208_input.executeFromDOM(this, event, scope);
  }

  async act_8320016629450276_showModal_4462_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8320016629450276_showModal_4462, alias=undefined
    return {
      name: "UploadMeterReadings",
    }
  }

  async evh_8320016629450276_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_click.executeFromDOM(this, event, scope);
  }

  async act_6806515264385235_reloadSlickgrid_4466_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_6806515264385235_reloadSlickgrid_4466, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_6806515264385235_close_4465_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_6806515264385235_close_4465, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_6806515264385235_showModal_4464_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_6806515264385235_showModal_4464, alias=undefined
    return {
      name: "MeterConsumption",
    }
  }

  async evh_6806515264385235_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6806515264385235_click.executeFromDOM(this, event, scope);
  }

  async act_8116269939469002_reloadSlickgrid_4470_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_8116269939469002_reloadSlickgrid_4470, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async act_8116269939469002_request_4468_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_8116269939469002_request_4468, alias=deleteItems
    return {
      operation: "bulk_delete_meter_consumption",
      data: {
        items: _.map(this.selectedItems, p => ({ id: p.id }))
      },
    }
  }

  async evh_8116269939469002_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8116269939469002_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_4450: actions.CloseModalAction;
    evh_7315092382398562_close_4449: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_setData_4452: actions.SetDataAction;
    evh_2248226175642056_selectedRowsChanged_4451: actions.EventHandlerImpl;
    evh_2248226175642056_selectedRowsChanged: actions.EventHandlerGroup;
    act_2248226175642056_reloadSlickgrid_4456: actions.ReloadSlickgridAction;
    evh_2248226175642056_close_4455: actions.EventHandlerImpl;
    act_2248226175642056_showModal_4454: actions.ShowModalAction;
    evh_2248226175642056_command_4453: actions.EventHandlerImpl;
    act_2248226175642056_showModal_4458: actions.ShowModalAction;
    evh_2248226175642056_command_4457: actions.EventHandlerImpl;
    evh_2248226175642056_command: actions.EventHandlerGroup;
    act_4615685607825208_reloadSlickgrid_4460: actions.ReloadSlickgridAction;
    evh_4615685607825208_input_4459: actions.EventHandlerImpl;
    evh_4615685607825208_input: actions.EventHandlerGroup;
    act_8320016629450276_showModal_4462: actions.ShowModalAction;
    evh_8320016629450276_click_4461: actions.EventHandlerImpl;
    evh_8320016629450276_click: actions.EventHandlerGroup;
    act_6806515264385235_reloadSlickgrid_4466: actions.ReloadSlickgridAction;
    evh_6806515264385235_close_4465: actions.EventHandlerImpl;
    act_6806515264385235_showModal_4464: actions.ShowModalAction;
    evh_6806515264385235_click_4463: actions.EventHandlerImpl;
    evh_6806515264385235_click: actions.EventHandlerGroup;
    act_8116269939469002_reloadSlickgrid_4470: actions.ReloadSlickgridAction;
    evh_8116269939469002_success_4469: actions.EventHandlerImpl;
    act_8116269939469002_request_4468: actions.RequestAction;
    evh_8116269939469002_click_4467: actions.EventHandlerImpl;
    evh_8116269939469002_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_4450 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_4450_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_4449 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_4450,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_4449],
      }
    );
    const act_2248226175642056_setData_4452 = new actions.SetDataAction(
      {
        actionArgs: this.act_2248226175642056_setData_4452_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_selectedRowsChanged_4451 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_setData_4452,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_2248226175642056_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_selectedRowsChanged_4451],
      }
    );
    const act_2248226175642056_reloadSlickgrid_4456 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2248226175642056_reloadSlickgrid_4456_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_close_4455 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_reloadSlickgrid_4456,
        event: "close",
        when: this.evh_2248226175642056_close_4455_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_2248226175642056_showModal_4454 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_4454_getActionArgs,
        events: [evh_2248226175642056_close_4455],
      }
    );
    const evh_2248226175642056_command_4453 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_4454,
        event: "command",
        when: this.evh_2248226175642056_command_4453_getWhen,
        displayName: "showModal",
      }
    );
    const act_2248226175642056_showModal_4458 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_4458_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_command_4457 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_4458,
        event: "command",
        when: this.evh_2248226175642056_command_4457_getWhen,
        displayName: "showModal",
      }
    );
    const evh_2248226175642056_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_command_4453, evh_2248226175642056_command_4457],
      }
    );
    const act_4615685607825208_reloadSlickgrid_4460 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_4615685607825208_reloadSlickgrid_4460_getActionArgs,
        events: [],
      }
    );
    const evh_4615685607825208_input_4459 = new actions.EventHandlerImpl(
      {
        action: act_4615685607825208_reloadSlickgrid_4460,
        event: "input",
        displayName: "reloadSlickgrid",
      }
    );
    const evh_4615685607825208_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_4615685607825208_input_4459],
      }
    );
    const act_8320016629450276_showModal_4462 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8320016629450276_showModal_4462_getActionArgs,
        events: [],
      }
    );
    const evh_8320016629450276_click_4461 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_showModal_4462,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_8320016629450276_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_click_4461],
      }
    );
    const act_6806515264385235_reloadSlickgrid_4466 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_6806515264385235_reloadSlickgrid_4466_getActionArgs,
        events: [],
      }
    );
    const evh_6806515264385235_close_4465 = new actions.EventHandlerImpl(
      {
        action: act_6806515264385235_reloadSlickgrid_4466,
        event: "close",
        when: this.evh_6806515264385235_close_4465_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_6806515264385235_showModal_4464 = new actions.ShowModalAction(
      {
        actionArgs: this.act_6806515264385235_showModal_4464_getActionArgs,
        events: [evh_6806515264385235_close_4465],
      }
    );
    const evh_6806515264385235_click_4463 = new actions.EventHandlerImpl(
      {
        action: act_6806515264385235_showModal_4464,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_6806515264385235_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_6806515264385235_click_4463],
      }
    );
    const act_8116269939469002_reloadSlickgrid_4470 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_8116269939469002_reloadSlickgrid_4470_getActionArgs,
        events: [],
      }
    );
    const evh_8116269939469002_success_4469 = new actions.EventHandlerImpl(
      {
        action: act_8116269939469002_reloadSlickgrid_4470,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_8116269939469002_request_4468 = new actions.RequestAction(
      {
        actionArgs: this.act_8116269939469002_request_4468_getActionArgs,
        displayName: "deleteItems",
        events: [evh_8116269939469002_success_4469],
      }
    );
    const evh_8116269939469002_click_4467 = new actions.EventHandlerImpl(
      {
        action: act_8116269939469002_request_4468,
        event: "click",
        displayName: "deleteItems",
      }
    );
    const evh_8116269939469002_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_8116269939469002_click_4467],
      }
    );
    return {
      act_7315092382398562_closeModal_4450,
      evh_7315092382398562_close_4449,
      evh_7315092382398562_close,
      act_2248226175642056_setData_4452,
      evh_2248226175642056_selectedRowsChanged_4451,
      evh_2248226175642056_selectedRowsChanged,
      act_2248226175642056_reloadSlickgrid_4456,
      evh_2248226175642056_close_4455,
      act_2248226175642056_showModal_4454,
      evh_2248226175642056_command_4453,
      act_2248226175642056_showModal_4458,
      evh_2248226175642056_command_4457,
      evh_2248226175642056_command,
      act_4615685607825208_reloadSlickgrid_4460,
      evh_4615685607825208_input_4459,
      evh_4615685607825208_input,
      act_8320016629450276_showModal_4462,
      evh_8320016629450276_click_4461,
      evh_8320016629450276_click,
      act_6806515264385235_reloadSlickgrid_4466,
      evh_6806515264385235_close_4465,
      act_6806515264385235_showModal_4464,
      evh_6806515264385235_click_4463,
      evh_6806515264385235_click,
      act_8116269939469002_reloadSlickgrid_4470,
      evh_8116269939469002_success_4469,
      act_8116269939469002_request_4468,
      evh_8116269939469002_click_4467,
      evh_8116269939469002_click,
      deleteItems: act_8116269939469002_request_4468,
    }
  }
}

Vue.component("MeterConsumptionBrowser", MeterConsumptionBrowser);

</script>